<style scoped lang="sass">
.dashboard-blank
  .upper
    position: relative
    display: flex
    flex-direction: column
    align-items: center
    padding: var(--base-padding) var(--base-padding) 0 var(--base-padding)
    background-color: var(--light-gray)
    .title
      font-size: 1.2rem
      font-weight: 700
      text-align: center
    .tag-line
      font-size: 1rem
      font-weight: 400
      text-align: center
    img
      max-width: 100%
    .button
      margin-top: -4rem
      height: 41px
      margin-bottom: calc(4rem - 41px)
  .lower
    padding: var(--base-padding)
    .quote
      font-size: 1rem
      font-weight: 300
      text-align: center
    .attribution
      font-size: 0.8rem
      font-weight: 600
      text-align: center
</style>
<template>
  <div class="dashboard-blank">
    <div class="upper">
      <div class="title">Welcome!</div>
      <div class="tag-line">Let's get you started.</div>
      <img src="images/dashboard-blank-golfer.png">
      <router-link :to="{name: 'newPool'}" class="button positive">Start a New Pool</router-link>
    </div>
    <div class="lower">
      <div class="quote">
        "Pinhigh is essential to managing my golf pools. Simple interface and real-time updates keep everyone aware of their changes during the back nine on Sunday."
      </div>
      <div class="attribution">- James Rollins</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DashboardBlank'
};
</script>
